<template>
  <div id="custMinProgSet">
    <el-row>
      <el-col :span="24"
              class="titleLine">
        <el-breadcrumb separator-class="el-icon-arrow-right"
                       class="titleLine1">
          <el-breadcrumb-item>客户</el-breadcrumb-item>
          <el-breadcrumb-item>客户设置</el-breadcrumb-item>
          <el-breadcrumb-item>客户小程序功能设置</el-breadcrumb-item>
        </el-breadcrumb>
      </el-col>
    </el-row>
    <el-form :inline="true"
             label-width="80px"
             class="pageSearch">
      <el-row>
        <el-col :span="24">
          <el-form-item label="所属分组::">
            <el-select v-model="pageSearch.fGrpID"
                       clearable
                       @change="loadOptions($event,true)"
                       placeholder="请选择所属分组">
              <el-option v-for="item in groupList"
                         :key="item.fGrpID"
                         :label="item.fGrpName"
                         :value="item.fGrpID">
              </el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="关键字::">
            <el-input placeholder="请输入客户编号/客户名称"
                      v-model="pageSearch.searchKeyWord"
                      style="width:200px">
              <!-- <i slot="prefix"
               class="el-input__icon el-icon-search"></i> -->
            </el-input>
          </el-form-item>
          <el-form-item>
            <el-button type="primary"
                       size="small"
                       icon="el-icon-search"
                       @click="init">查询</el-button>
          </el-form-item>
        </el-col>
      </el-row>
    </el-form>
    <el-row>
      <el-col :span="24"
              style="height: 5px"></el-col>
    </el-row>
    <el-row>
      <el-col :span="24">
        <el-table :data="pageData"
                  :height="tableHeight"
                  highlight-current-row
                  v-loading="loading"
                  border
                  stripe
                  style="width: 100%">
          <el-table-column width="50"
                           type="index"
                           :index="indexMethod"
                           label="序号"
                           align="right">
          </el-table-column>
          <el-table-column prop="fCustNo"
                           label="客户编号"
                           width="80"
                           align="center">
          </el-table-column>
          <el-table-column prop="fCustName"
                           width="135"
                           label="客户名称">
          </el-table-column>
          <el-table-column prop="fGrpName"
                           width="135"
                           label="所属分组">
          </el-table-column>
          <el-table-column prop="fOpLastTime"
                           label="最后操作时间"
                           width="150px"
                           align="center">
          </el-table-column>
          <el-table-column prop="fHasPayTitle"
                           label="停车缴费"
                           align="center">
          </el-table-column>
          <el-table-column prop="fHasInvTitle"
                           label="电子发票"
                           align="center">
          </el-table-column>
          <el-table-column prop="fHasPlaGuiTitle"
                           label="车位引导"
                           align="center">
          </el-table-column>
          <el-table-column prop="fPlaGuiName"
                           label="车位引导地图名称"
                           width="150px"
                           align="center">
          </el-table-column>
          <el-table-column prop="fHasPlaStaTitle"
                           label="车位状态"
                           align="center">
          </el-table-column>
          <el-table-column prop="fHasResTitle"
                           label="停车预约"
                           align="center">
          </el-table-column>
          <el-table-column prop="fResTimes"
                           label="预约时效"
                           fixed="right"
                           align="right">
          </el-table-column>
          <el-table-column prop="fResAmt"
                           label="预约保证金"
                           fixed="right"
                           align="right">
          </el-table-column>
          <el-table-column label="操作"
                           align="center"
                           fixed="right"
                           width="180">
            <template slot-scope="scope">
              <el-button size="mini"
                         type="success"
                         @click="handleInfo(scope.$index, scope.row)">查看</el-button>
              <el-button size="mini"
                         type="warning"
                         v-if="is_edit"
                         @click="handleEdit(scope.$index, scope.row)">编辑</el-button>
            </template>
          </el-table-column>
        </el-table>
      </el-col>
    </el-row>
    <el-row class="pagination">
      <el-col :span="24">
        <div class="block">
          <span class="demonstration"></span>
          <el-pagination @current-change="handleCurrentChange"
                         @size-change="handleSizeChange"
                         :current-page="pageSearch.pageIndex"
                         :page-size="pageSearch.pageSize"
                         :page-sizes="[10, 20, 50, 100]"
                         background
                         layout="total,sizes, prev, pager, next, jumper"
                         :total="pageCount"
                         v-if="pageCount>0">
          </el-pagination>
        </div>
      </el-col>
    </el-row>
    <el-dialog :title="dialogEditTitle"
               top="20vh"
               width="43%"
               v-dialogDrag
               :visible.sync="dialogFormEditVisible">
      <el-form label-width="123px"
               :model="cust"
               :rules="rules"
               ref="ruleForm">
       <el-row>
          <el-col :span="12">
            <el-form-item label="停车缴费::">
              <el-radio-group v-model="cust.fHasPay"
                              :disabled="formDisabled">
                <el-radio :label="true">已开启</el-radio>
                <el-radio :label="false">未开启</el-radio>
              </el-radio-group>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row>
          <el-col :span="12">
            <el-form-item label="电子发票::">
              <el-radio-group v-model="cust.fHasInv"
                              :disabled="formDisabled">
                <el-radio :label="true">已开启</el-radio>
                <el-radio :label="false">未开启</el-radio>
              </el-radio-group>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row>
          <el-col :span="9">
            <el-form-item label="车位引导::">
              <el-radio-group v-model="cust.fHasPlaGui"
                              :disabled="formDisabled">
                <el-radio :label="true">已开启</el-radio>
                <el-radio :label="false">未开启</el-radio>
              </el-radio-group>
            </el-form-item>
          </el-col>
          <el-col :span="10" v-if="cust.fHasPlaGui">
            <el-form-item label="车位地图名称::"
                              prop="fPlaGuiName">
              <el-input v-model="cust.fPlaGuiName"
                        style="width:80%"
                        :disabled="formDisabled"></el-input>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row>
          <el-col :span="12">
            <el-form-item label="车位状态::">
              <el-radio-group v-model="cust.fHasPlaSta"
                              :disabled="formDisabled">
                <el-radio :label="true">已开启</el-radio>
                <el-radio :label="false">未开启</el-radio>
              </el-radio-group>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row>
          <el-col :span="9" >
            <el-form-item label="停车预约::">
              <!--<el-radio-group v-model="cust.fHasRes"
                              :disabled="formDisabled">
                <el-radio :label="true">已开启</el-radio>
                <el-radio :label="false">未开启</el-radio>
              </el-radio-group>-->
              <el-select v-model="cust.fHasRes"
                         filterable
                         style="width:120px">
                <el-option v-for="item in ReserveItems"
                           :key="item.value"
                           :label="item.label"
                           :value="item.value">
                </el-option>
              </el-select>
            </el-form-item>
          </el-col>
          <el-col :span="7" v-if="cust.fHasRes!=='0'">
            <el-form-item label="预约时效(分钟):"
                                prop="fResTimes">
              <el-input v-model="cust.fResTimes"
                        style="width:80%"
                        :disabled="formDisabled"></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="7" v-if="cust.fHasRes!=='0'">
            <el-form-item label="预约保证金(元)::"
                                prop="fResAmt">
              <el-input v-model="cust.fResAmt"
                        style="width:80%"
                        :disabled="formDisabled"></el-input>
            </el-form-item>
          </el-col>
        </el-row>
      </el-form>
      <div class="dialog-footer"
           slot="footer">
        <el-button type="primary"
                   v-if="!formDisabled"
                   @click="submitForm('ruleForm')">保存</el-button>
        <el-button @click="dialogFormEditVisible = false">取消</el-button>
      </div>
    </el-dialog>
  </div>
</template>
<script>
import { cust as api } from '../../api/cust'
import * as user from '../../api/user'
// import $ from 'jquery'
const delay = (function () {
  let timer = 0
  return function (callback, ms) {
    clearTimeout(timer)
    timer = setTimeout(callback, ms)
  }
})()
export default {
  data () {
    var checkfFee = (rule, value, callback) => {
      if (!/^(([1-9]{1}\d*)|(0{1}))(\.\d{0,2})?$/.test(value)) {
        return callback(new Error('请填写数字（最多保留两位小数）'))
      } else {
        callback()
      }
    }
    var valInt = (rule, value, callback) => {
      if (!/^[0-9]+$/.test(value)) {
        callback(new Error('请填写正整数'))
      }
      callback()
    }
    return {
      is_edit: false,
      formDisabled: false,
      tableHeight: 0,
      dialogFormVisible: false,
      dialogFormEditVisible: false,
      loading: true,
      dialogEditTitle: '',
      pageData: [],
      search_userList: [],
      userList: [],
      groupList: [],
      pageCount: 0,
      custTypeIDList: [{ value: '0', label: '封闭式场库' }, { value: '1', label: '路侧场库' }],
      pageSearch: {
        pageIndex: 1,
        pageSize: 20,
        fCustTypeID: '',
        fGrpID: '',
        fUsrID: '',
        searchKeyWord: '',
        isExport: 0
      },
      cust: {
        fHasPay: false,
        fHasInv: false,
        fHasPlaGui: false,
        fPlaGuiName: '',
        fHasPlaSta: false,
        fHasRes: '0',
        fResTimes: '30',
        fResAmt: '0'
      },
      ReserveItems: [{ value: '0', label: '无' }, { value: '1', label: '普通预约' }, { value: '2', label: 'PLC预约模式' }],
      rules: {
        fResTimes: [
          { required: true, message: '请输入预约时效', trigger: 'change' },
          { validator: valInt, trigger: 'blur' }
        ],
        fPlaGuiName: [
          { required: true, message: '请输入车位地图名称', trigger: 'change' }
        ],
        fResAmt: [
          { required: true, message: '请输入预约保证金', trigger: 'change' },
          { validator: checkfFee, trigger: 'blur' }
        ]
      }
    }
  },
  methods: {
    // 搜索词搜索
    wordSearch () {
      delay(() => {
        this.init()
      }, 1000)
    },
    init (index) {
      if (index && index >= 1) {
        this.pageSearch.pageIndex = index
      } else {
        this.pageSearch.pageIndex = 1
      }
      this.pageSearch.isExport = 0
      this.loading = true
      api.custMiniProgPageList(this.pageSearch).then(res => {
        this.loading = false
        if (res && res.data) {
          var data = res.data
          if (data.IsOk) {
            this.pageData = data.Data.data
            this.pageCount = data.Data.count
          } else {
            this.$message.error('提示：加载客户信息失败')
          }
        }
      })
    },
    formatType (row, column, cellValue, index) {
      if (cellValue === '0') {
        return '封闭式'
      } else {
        return '路侧'
      }
    },
    exportData () {
      this.export_loading = true
      this.export_msg = '导出中……'
      this.pageSearch.isExport = 1
      api.custPageList(this.pageSearch).then(res => {
        this.export_loading = false
        this.export_msg = '导出'
        if (res && res.data) {
          var data = res.data
          if (data.IsOk) {
            if (data.Data) {
              this.fileDownload(data.Data, '客户列表.xls')
            }
          } else {
            this.$message.error('提示：' + data.Msg)
          }
        }
      })
    },
    indexMethod (index) {
      return this.pageSearch.pageSize * (this.pageSearch.pageIndex - 1) + index + 1
    },
    handleSizeChange (val) {
      this.pageSearch.pageSize = val
      this.init(this.pageSearch.pageIndex)
    },
    handleCurrentChange (val) {
      this.init(val)
    },
    handleInfo (index, row) {
      this.cust = []
      this.dialogEditTitle = '【' + row.fCustNo + ':' + row.fCustName + '】查看客户小程序功能设置信息'
      this.formDisabled = true
      this.dialogFormEditVisible = true
      api.getCustMiniProgData(row).then(res => {
        if (res && res.data) {
          var data = res.data
          if (data.IsOk) {
            data.Data = data.Data || {}
            if (data.Data.fBigRowID === 0) {
              this.cust.fHasPay = false
              this.cust.fHasInv = false
              this.cust.fHasPlaGui = false
              this.cust.fPlaGuiName = ''
              this.cust.fHasPlaSta = false
              this.cust.fHasRes = '0'
              this.cust.fResTimes = '30'
              this.cust.fResAmt = '0'
            } else {
              this.cust = data.Data.data[0]
            }
          } else {
            this.$message.error(data.Msg)
          }
        }
      })
    },
    handleEdit (index, row) {
      this.dialogEditTitle = '【' + row.fCustNo + ':' + row.fCustName + '】编辑客户小程序功能设置'
      this.formDisabled = false
      if (this.$refs['ruleForm']) {
        this.$refs['ruleForm'].resetFields()
      }
      this.dialogFormEditVisible = true
      api.getCustMiniProgData(row).then(res => {
        if (res && res.data) {
          var data = res.data
          if (data.IsOk) {
            data.Data = data.Data || {}
            if (data.Data.fBigRowID === 0) {
              this.cust.fHasPay = false
              this.cust.fHasInv = false
              this.cust.fHasPlaGui = false
              this.cust.fPlaGuiName = ''
              this.cust.fHasPlaSta = false
              this.cust.fHasRes = '0'
              this.cust.fResTimes = '30'
              this.cust.fResAmt = '0'
            } else {
              this.cust = data.Data.data[0]
            }
          } else {
            this.$message.error(data.Msg)
          }
        }
      })
    },
    submitForm (formName) {
      this.$refs[formName].validate((valid) => {
        if (valid) {
          if (this.cust.fHasPlaGui === true && this.cust.fPlaGuiName === '') {
            this.$message.error('车位地图服务名称不能为空')
            return
          }
          api.custMiniProgSetEdit(this.cust).then(res => {
            if (res && res.data) {
              var data = res.data
              if (data.IsOk) {
                this.dialogFormEditVisible = false
                this.$message({
                  type: 'success',
                  message: data.Msg
                })
                this.init(this.pageSearch.pageIndex)
              } else {
                this.$message.error(data.Msg)
              }
            }
          })
        }
      })
    },
    setTableHeight (obj) {
      let clientHeight = obj.getRJPageSize.getRJPageSize()[3] - 250
      obj.tableHeight = clientHeight
    },
    setDetailTableHeight (obj) {
      let clientHeight = obj.getRJPageSize.getRJPageSize()[3] - 25 - 560
      obj.tableDetailHeight = clientHeight
    },
    loadOptions (val, isSearch) {
      if (isSearch) {
        this.search_userList = []
        this.pageSearch.fUsrID = ''
      } else {
        this.cust.fUsrID = ''
        this.userList = []
      }
      api.allCustUser(val).then(res => {
        if (res && res.data) {
          var data = res.data
          if (data.IsOk) {
            if (isSearch) {
              this.search_userList = data.Data || []
            } else {
              this.userList = data.Data || []
            }
          } else {
            this.$message.error('加载业务员失败')
          }
        }
      })
    },
    loadGroups () {
      api.groupList().then(res => {
        if (res && res.data) {
          var data = res.data
          if (data.IsOk) {
            this.groupList = data.Data
          } else {
            this.$message.error('加载所属分组失败')
          }
        }
      })
    }
  },
  created () {
    user.getCurrentUserPers({ perTypeId: 43000 }).then(res => {
      if (res && res.data) {
        var data = res.data
        if (data.IsOk) {
          if (data.Data) {
            this.is_edit = data.Data.data.is_edit
          }
        } else {
          this.$message.error('提示：加载当前用户权限信息失败')
        }
      }
    })
  },
  mounted () {
    window.onresize = () => {
      this.setTableHeight(this)
    }
    this.init()
    this.loadGroups()
  },
  updated () {
    this.setTableHeight(this)
  }
}
</script>
<style>
/* dialog弹出框样式 */
#custMinProgSet .el-dialog__headerbtn {
  top: 10px;
  font-size: 20px;
}
#custMinProgSet .el-dialog__title {
  color: white;
}
#custMinProgSet .el-dialog__header {
  background-color: #337ab7;
  padding: 10px;
}
#custMinProgSet .el-dialog__body {
  padding: 30px 20px 0px 20px;
}
#custMinProgSet .is-disabled .el-input__inner,
#custMinProgSet .is-disabled .el-textarea__inner {
  color: #606266;
}
#custMinProgSet #fRemark {
  height: 180px;
}
#custMinProgSet .fRemark_row .el-form-item__content {
  height: 180px;
}
</style>
<style scoped>
.el-dropdown-link {
  cursor: pointer;
  color: #409eff;
}
.pageSearch .el-form-item {
  margin-bottom: 5px;
}
.pagination {
  text-align: right;
  padding-top: 5px;
}
.search {
  width: 300px;
}
.searchRowAdd {
  text-align: right;
}
</style>



// WEBPACK FOOTER //
// src/view/cust/custMinProgSet.vue